import { useEffect } from 'react'
import zionDebug from '@fs/zion-debug'

const debug = zionDebug('identity:hooks')

export default function useFormResetOnSubmitSuccess(methods, defaultValues) {
  const {
    formState: { isSubmitSuccessful },
    reset,
  } = methods

  useEffect(() => {
    if (isSubmitSuccessful) {
      debug('Resetting form with new defaultValues')
      reset(defaultValues)
    }
  }, [defaultValues, isSubmitSuccessful, reset])
}
